import React from 'react';
import { useAtomValue } from 'jotai';
import { settingsAtom } from "../../atoms/settingsAtom";

// Utility function to get nested property value from an object
const getNestedProperty = (obj, path) =>
path.
split('.').
reduce(
  (current, key) => current && current[key] !== undefined ? current[key] : undefined,
  obj
);

const FeatureToggle = ({ feature, children }) => {var _getNestedProperty;
  const settings = useAtomValue(settingsAtom);
  const featureActivated = (_getNestedProperty = getNestedProperty(settings.features, feature)) !== null && _getNestedProperty !== void 0 ? _getNestedProperty : false;
  return featureActivated ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};

export { FeatureToggle };